import React from 'react';
import Tag from '../components/ui/Tag';
import type { TagTone } from '../components/ui/Tag';
import { readingText } from './shipping';
import type { ShippingReadingSummary } from './shipping';

const TONE: Record<string, TagTone> = {
  partly: 'warn',
  shipped: 'good',
  not_shipped: 'neutral',
};

/** How much of an order has left the building, in words. Nothing renders for an order with nothing shipped. */
const ReadingBadge: React.FC<{ reading: ShippingReadingSummary | null | undefined }> = ({ reading }) => {
  if (!reading) return null;
  const text = readingText(reading);
  if (!text) return null;
  return (
    <Tag size="sm" tone={TONE[reading.state] || TONE.not_shipped} className="tabular-nums">
      {text}
    </Tag>
  );
};

export default ReadingBadge;
